import React, { useEffect, useRef } from "react";
import { Tooltip } from 'bootstrap';

const ChartSection = ({ monthlyData = [], selectedRange }) => {
  const chartRef = useRef(null);

  // Initialize tooltips after component mounts and cleanup on unmount
  useEffect(() => {
    const tooltipTriggerList = chartRef.current?.querySelectorAll('[data-bs-toggle="tooltip"]');
    
    if (tooltipTriggerList) {
      // Convert to array and initialize tooltips
      const tooltips = [...tooltipTriggerList].map(
        tooltipTriggerEl => new Tooltip(tooltipTriggerEl, {
          trigger: 'hover'
        })
      );

      // Cleanup function
      return () => {
        tooltips.forEach(tooltip => {
          try {
            tooltip.dispose();
          } catch (e) {
            console.log('Tooltip cleanup error:', e);
          }
        });
      };
    }
  }, [monthlyData]); // Only re-run when monthlyData changes

  const maxIncomeExpense = Math.max(
    ...monthlyData.map((data) => Math.max(data.income || 0, data.expense || 0))
  );

  return (
    <div
      ref={chartRef}
      className="d-flex align-items-end justify-content-between gap-2 mb-5"
      style={{ height: "200px" }}
    >
      {monthlyData.map((data, index) => {
        const incomeHeightPx = maxIncomeExpense ? (data.income / maxIncomeExpense) * 200 : 0;
        const expenseHeightPx = maxIncomeExpense ? (data.expense / maxIncomeExpense) * 200 : 0;

        return (
          <div
            key={`${data.month}-${index}-${selectedRange}`}
            className="d-flex flex-column align-items-center gap-1 flex-grow-1"
          >
            <div
              className="d-flex align-items-end gap-1"
              style={{ width: "1.5rem", height: "100%" }}
            >
              {/* Income Bar */}
              {incomeHeightPx > 0 && (
                <div
                  className="bg-white rounded-top bar-hover"
                  style={{
                    width: "100%",
                    height: `${incomeHeightPx}px`,
                    transition: "height 0.3s ease",
                  }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-original-title={`Income: $${data.income?.toFixed(2) || 0}`}
                ></div>
              )}
              
              {/* Expense Bar */}
              {expenseHeightPx > 0 && (
                <div
                  className="rounded-top bar-hover"
                  style={{
                    width: "100%",
                    height: `${expenseHeightPx}px`,
                    backgroundColor: "#FFD700",
                    transition: "height 0.3s ease",
                  }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-original-title={`Expense: $${data.expense?.toFixed(2) || 0}`}
                ></div>
              )}
            </div>
            <span className="small text-white">{data.month}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ChartSection;
